
import { Component, Prop, Vue } from "vue-property-decorator";
import FinderVue from "@/finder/Finder.vue";
import  ButtonVue from "@/lib/Button.vue";
import { Next, Route } from 'vue-router';

import  ClipAddMultiVue from "@/clip/ClipAddMulti.vue";
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();


 @Component({
      components: { FinderVue, ButtonVue,ClipAddMultiVue }
})
export default class POHistoryVue extends Vue {

    @Prop(String) PO_id!: string;

    filter:string="";
    edi_results: any[]=[];
    key:number=0;

 
    async mounted() {

      const ret = await bus.api("/api/edi/raflatac/get_edi_results_for_po",{PO_id: parseInt(this.PO_id)});
      console.log(ret)
      if (ret) { this.edi_results = ret } 
      else return this.edi_results = []

      for (let r of this.edi_results) {
        try {
          r.poc = JSON.parse(r.poc)
        } catch (err) {
          //
        }
      }

      this.key++

    }

    async beforeDestroy() { }

}


